/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=2e0cd5e6"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=2e0cd5e6&lang=scss"

import exportComponent from "../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__